<script lang="ts">
    import "dayjs/locale/id";
    dayjs.locale("id");

    import { dayjs } from "svelte-time";
    import { goto } from "$app/navigation";
    import { Splide, SplideSlide } from "@splidejs/svelte-splide";

    import "@splidejs/svelte-splide/css/core";
    import Time from "svelte-time";

    export let data: any = [];
    export let data_detail: any = [];

    $: detail_news = data_detail;
    $: news = data?.data
        .filter((item: any) => item.id !== detail_news?.id)
        .slice(0, 5);
</script>

<section class="flex flex-col gap-x-6 gap-y-6 w-full">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    {#if news}
        {#each news as post}
            {#if post?.id !== detail_news?.id}
                <a
                    href={`/news/${post?.slug}`}
                    class="no-underline hover:no-underline news-content-item flex 4xs:flex-col 4xs:items-start gap-[10px] cursor-pointer group"
                >
                    <div
                        class="news__image rounded-[8px] relative overflow-hidden w-[40%] 4xs:w-full aspect-video"
                    >
                        <img
                            loading="lazy"
                            src={`${
                                post?.featured_images?.data?.[0]?.original ||
                                post?.featured_images?.data?.[0]?.large ||
                                post?.featured_images?.data?.[0]?.medium ||
                                post?.featured_images?.data?.[0]?.thumb ||
                                post?.featured_images?.data?.[0]?.small
                            }`}
                            alt={post?.title}
                            class="rounded-[10px] object-cover 4xs:object-top object-left-center w-full aspect-ratio"
                        />
                    </div>
                    <div class="w-[60%] 4xs:w-full">
                        <!-- <Splide
                class='cursor-grab'
                options={{
                    gap: '10px',
                    wheel: true,
                    drag: 'free',
                    type: 'slide',
                    rewind : false,
                    autoWidth: true,
                    wheelSleep: 200,
                    waitForTransition: true,
                }}
                aria-label="News Categories"
            >
              {#if post?.categories?.data}
                {#each post?.categories?.data as category}
                  <SplideSlide> 
                    <a
                      class="text-slate-700 bg-slate-200 hover:bg-slate-300/80 no-underline hover:no-underline text-[12px] p-2 rounded-[10px] cursor-pointer transition-colors duration-200"
                      href="/news/categories/{category?.slug}"
                    >
                      {category?.name}
                    </a>
                  </SplideSlide>
                {:else}
                  <div
                    class="text-slate-700 bg-slate-200 hover:bg-slate-300/80 no-underline hover:no-underline text-[12px] p-2 rounded-[10px] cursor-pointer flex items-center gap-1 transition-colors duration-200"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="mt-[2px]" fill='currentColor' width="18" height="18" aria-label="Tag Category" ><g><path d="M5.653 14.48a1.386 1.386 0 0 0 .985-.408l7.161-7.161a2.309 2.309 0 0 0 .68-1.642V1.391A1.4 1.4 0 0 0 13.085 0H9.21a2.307 2.307 0 0 0-1.642.68L.407 7.841a1.4 1.4 0 0 0 0 1.971l4.261 4.261a1.383 1.383 0 0 0 .985.407ZM13.085.929a.465.465 0 0 1 .465.465v3.875a1.384 1.384 0 0 1-.408.985l-7.161 7.162a.465.465 0 0 1-.657 0l-4.26-4.262a.466.466 0 0 1 0-.657l7.161-7.16A1.386 1.386 0 0 1 9.21.929Z"></path><path d="M10.763 5.11a1.394 1.394 0 1 0-1.394-1.393 1.395 1.395 0 0 0 1.394 1.393Zm0-1.858a.465.465 0 1 1-.465.465.465.465 0 0 1 .465-.465Z"></path></g></svg>
                    <span>
                      Uncategorized
                    </span>
                </div>
                {/each}
              {/if}
  
              <div class="splide__arrows hidden"></div>
              <ul class="splide__pagination"></ul>
            </Splide> -->
                        <div on:click={() => goto(`/news/${post?.slug}`)}>
                            <div
                                class="line-clamp-2 text-slate-700 text-[15px] font-semibold group-hover:text-opacity-80 transition-colors duration-200"
                            >
                                <span>{post?.title}</span>
                            </div>
                            <div
                                class="text-[13px] font-normal text-[#3E3232BF] mt-1 group-hover:text-opacity-80 transition-colors duration-200"
                            >
                                <Time
                                    timestamp={post?.published_at}
                                    format={`D MMMM YYYY HH:mm`}
                                />
                                {new Date(post?.published_at)
                                    .toLocaleString("id-ID", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: false,
                                        timeZoneName: "short",
                                    })
                                    ?.split(" ")?.[1]}
                                <!-- {`${ (Intl.DateTimeFormat(undefined, {timeZoneName: 'longGeneric'})?.formatToParts(new Date(post?.published_at))?.find((part) => part?.type == 'timeZoneName')?.value) === 'Western Indonesia Time' ? 'WIB' : (Intl.DateTimeFormat(undefined, {timeZoneName: 'longGeneric'})?.formatToParts(new Date(post?.published_at))?.find((part) => part?.type == 'timeZoneName')?.value) === 'Eastern Indonesia Time' ? 'WIT' : 'WITA' }`} -->
                            </div>
                        </div>
                    </div>
                </a>
            {/if}
        {/each}
    {/if}
</section>

<style>
    .splide__arrows {
        display: none !important;
    }
    .splide__pagination {
        display: none !important;
    }
</style>
